module.exports = __webpack_public_path__ + "img/sunhero_logos_pic.cbd98d04.png";